import { render, staticRenderFns } from "./OpsEdit.vue?vue&type=template&id=71f3bf32&scoped=true&"
import script from "./OpsEdit.vue?vue&type=script&lang=js&"
export * from "./OpsEdit.vue?vue&type=script&lang=js&"
import style0 from "./OpsEdit.vue?vue&type=style&index=0&id=71f3bf32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f3bf32",
  null
  
)

export default component.exports